import { gql } from 'graphql-tag'

import { FRAGMENT_AVATAR_USER } from '@/components/Worlds/UI/Avatar/Avatar.hasura'

export const FRAGMENT_MESSAGE_PLAIN_V1_MESSAGE = gql`
  fragment MessagePlainV1Message on message {
    id
    type
    body_safe
    attachment_urls_safe
    created_at
    last_edited_at
    hidden_at
    user {
      id
      virtual_display_name
      ...AvatarUser
    }
    message_reactions {
      reaction
      user {
        id
        virtual_display_name
      }
      created_at
    }
  }

  ${FRAGMENT_AVATAR_USER}
`
